import { selectedFieldAssetsStore } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'
import { OfflineRequestError } from 'utils/errorCodes'
import { serviceCenterStore } from '../store/serviceCenterStore'
import type { TActiveNode, TPlannedNode } from '../types'
import { ApiRequestQueue } from './api/queue'
import { ApiRequestStatus, ApiRequestType } from './api/queue/types'
import type { NodeRemoveMeta } from './api/serviceCenterNodeRemove'

export const removeNode = async (param: NodeRemoveMeta, replan = false) => {
  let unsynced = true

  try {
    // Request may or may not have been completed by the time the promise resolves
    if (replan) {
      const { status } = await ApiRequestQueue.createRequest(ApiRequestType.REPLAN_NODE, {
        nodeIdentifiers: [param.nodeIdentifier],
        propertyId: param.propertyId,
      })

      if (status === ApiRequestStatus.COMPLETED) unsynced = false
    } else {
      const { status } = await ApiRequestQueue.createRequest(ApiRequestType.REMOVE_NODE, param)

      if (status === ApiRequestStatus.COMPLETED) unsynced = false
    }
  } catch (error) {
    // If the request failed because the app is offline, don't throw an error
    if (!(error instanceof OfflineRequestError)) {
      throw error
    }
  }

  if (unsynced) {
    if (replan) {
      const activeNodes = serviceCenterStore.selectors.getActiveNodesForSelectedProperties(
        serviceCenterStore.getState(),
        selectedFieldAssetsStore.getState().property,
      )

      // Create fake planned nodes based on the removed active nodes to show in the UI while offline
      const replannedActiveNodes = (activeNodes as TActiveNode[])
        .filter((n) => param.nodeIdentifier === n.nodeIdentifier)
        .map((node) => {
          const randomNodeId = Math.floor(Math.random() * 1000000) // Generate a random node ID for the new planned node. In a real implementation, this should come from the backend after creating the planned node.

          // Transform active nodes to planned nodes
          return {
            pseudonodeId: String(-randomNodeId),
            id: String(-randomNodeId),
            nodeType: node.nodeType,
            location: node.location,
            name: node.name,
            propertyId: node.propertyId,
            blockId: null,
            managementType: node.managementType,
            maintenanceOwnerId: node.maintenanceOwnerId,
            gatewayMac: node.gatewayIdentifier,
            devices: node.devices,
            insectId: node.trap?.targetInsectId,
            hiddenFromCustomer: false,
            notes: '',
          } as TPlannedNode
        })

      serviceCenterStore.actions.updatePlannedNodes(replannedActiveNodes)
    }

    serviceCenterStore.actions.removeActiveNodes([param.nodeIdentifier])
  }
}
